import { useEffect } from 'react';

import { getSystemTheme, type ResolvedTheme } from '@/app/contexts/theme';
import { EVENTS, gtag } from '@/lib/gtag';

const APP = 'onsite.ergeon.com';

const browserCannotTellTheSystemScheme = () => typeof window.matchMedia !== 'function';

const shownTheme = (): ResolvedTheme => {
  if (document.documentElement.classList.contains('dark')) {
    return 'dark';
  }
  return 'light';
};

export const recordColorScheme = () => {
  if (browserCannotTellTheSystemScheme()) {
    return;
  }

  try {
    gtag(EVENTS.COLOR_SCHEME, { app: APP, prefers: getSystemTheme(), shown: shownTheme() });
  } catch {
    return;
  }
};

export const useColorSchemeRecording = () => {
  useEffect(recordColorScheme, []);
};
